//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapMutations } from "vuex";
export default {
  name: "FilteringSearch",
  computed: {
    ...mapGetters(["search"]),
    model: {
      get() {
        return this.search;
      },
      set(value) {
        this.setSearch(value);
      },
    },
  },
  methods: {
    ...mapMutations(["setSearch"]),
  },
};
